let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bEDNR")).then(() => parcelRequire('hHvP0'));